import FormContainer, { TextInputType } from '../formContainer/FormContainer'
import PhoneNumberValidation from '../../api/PhoneNumberValidation'
import NormalizeInput from './PhoneNumberUtility'
import PropTypes from 'prop-types'
import { PhoneNumberSize } from '../constants/EditProfileConstants'
import { useState } from 'react'
import { errorLength, errorPhoneExist, phoneNumberMarkup } from '../constants/Validations' 

export default function PhoneSection( props ) {

    const [ mobilePhoneNumber, setPhoneNumber ] = useState( props.currentPhoneNumber ? NormalizeInput( props.currentPhoneNumber ) : '' )
    const [ phoneNumberValueChanged, setPhoneNumberValueChanged ] = useState( props.currentPhoneNumber ? NormalizeInput( props.currentPhoneNumber ) : '' )
    const [ mobilePhoneNumberError, setPhoneNumberError ] = useState( '' )
      
    const handlePhoneValue = e =>
    {
        setPhoneNumber( NormalizeInput(  e.target.value ) )
        props.setPhoneNumberValue( NormalizeInput( e.target.value ) )
        setPhoneNumberError( null )
        
        if( e.target.value !== NormalizeInput( props.currentPhoneNumber ) ) {
            props.setPhoneNumberIsValid( false )
        } else {
            props.setPhoneNumberIsValid( true )
        }
    }
  
    const handlePhoneInput = e => 
    {
        if( e.target.value === NormalizeInput( props.currentPhoneNumber )  )
        {
            setPhoneNumberError( null )
            setPhoneNumberValueChanged( e.target.value )
            props.setPhoneNumberIsValid( true )
            return
        }

        if( e.target.value.length === PhoneNumberSize.MinPhoneNumberSize ) 
        {
            setPhoneNumberError( null )
            setPhoneNumberValueChanged( e.target.value )
            props.setPhoneNumberIsValid( true )
            props.setPhoneNumberValue( '' )
            return
        }

        if( e.target.value.length > PhoneNumberSize.MinPhoneNumberSize && e.target.value.length < PhoneNumberSize.MaxPhoneNumberSize ) 
        {
            setPhoneNumberError( errorLength )
            props.setPhoneNumberIsValid( false )
        }
        else
        {   
            if( e.target.value !== phoneNumberValueChanged )
            {
                setPhoneNumberError( null )
                props.setIsPhoneValidationLoading( true )
                PhoneNumberValidation( { apiUrl: process.env.REACT_APP_PHONE_NUMBER_VALIDATION_API, phoneNumber: e.target.value, webId: props.webId ? props.webId : ''  } )
                .then( data => {
                    if( data === true ){
                        setPhoneNumberError( errorPhoneExist )
                        props.setPhoneNumberIsValid( false )
                    }else{
                        setPhoneNumberError( null )
                        props.setPhoneNumberIsValid( true )
                    }
                } )
                .catch( data => {
                    props.setPhoneNumberIsValid( false )
                    setPhoneNumberError( errorPhoneExist )
                    console.error( data )
                } )
                .finally( _ => {
                    props.setIsPhoneValidationLoading( false )
                    setPhoneNumberValueChanged( e.target.value )
                } )
            }
        }
    }

    return !props.disabled && (
        <FormContainer 
            formTitle = "Phone Number"
            formTitleAdaMsg = { 'Phone Number section. ' + phoneNumberMarkup }
            formTitleClassName = "c-form-intro c-form-intro--long"
            containerClassName = "c-form-container c-form-container--box mb-5"
            formInputsClass =  'c-form-container-in-column'
            formInputComponents = { [ 
                { 
                    ...props.phoneNumberConfig,
                    invalidText: mobilePhoneNumberError,
                    invalid: mobilePhoneNumberError ? true : false ,
                    value: mobilePhoneNumber,
                    labelText: 'Phone',
                    id: 'Phone',
                    type: 'text',
                    autoComplete: 'false',
                    tabIndex: 0,
                    ariaLabel: 'Phone Number. Optional field.',
                    visible: true,
                    className: 'c-form-custom-input',
                    inputType: TextInputType,
                    onChange: handlePhoneValue,
                    onBlur: handlePhoneInput
                }, 
            ] }
            notificationVisible = { true }
            showInputComponentsInColum = { true }
            notification = {
                {
                    contentWrapper: 'c-form-notification-box',
                    visible: true,
                    style: 'info',
                    markup: phoneNumberMarkup
                }
            }
        >
        </FormContainer>
    )
}

PhoneSection.propTypes = {
    phoneNumberConfig: PropTypes.instanceOf( Object ),
    disabled: PropTypes.bool,
    setPhoneNumberValue: PropTypes.func.isRequired,    
    setPhoneNumberIsValid: PropTypes.func.isRequired,
    setIsPhoneValidationLoading: PropTypes.func.isRequired,
    currentPhoneNumber: PropTypes.string,
    webId: PropTypes.string
}